import React, { useEffect, useState } from "react";
import "../styles/calendar.css";
import CalendarViews from "./calendar_views.js";
import YearReportPopUp from "./yearReport_popup.js";
import { secretKey, monthData } from "../.././data";
import Loading from "../helpers/loading_component.js";
import Swal from "sweetalert2";
import DatePopUp from "./date_popup.js";

const Calendar = (props) => {
  const [monthName, setMonthName] = useState("");
  const [monthNameDisabled, setMonthNameDisabled] = useState("");
  const [weekName, setWeekName] = useState("");
  const [yearName, setYearName] = useState("");
  const [dayName, setDayName] = useState("");
  const [showReportPopUp, setShowReportPopUp] = useState(false);
  const [monthId, setMonthId] = useState("");
  const [dateC, setDateC] = useState(props.date);
  const [expandFilters, setExpandFilters] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [hearings, setHearings] = useState([]);
  const [users, setUsers] = useState([]);
  const [subst, setSubst] = useState("");
  const [loading, setLoading] = useState(true);
  const [sellTasks, setSellTasks] = useState([]);
  const [expandMobileFilters, setExpandMobileFilters] = useState(false);
  const [hearingsPotrCl, setHearingsPotrCl] = useState(false);
  const [teorSald, setTeorSald] = useState(false);
  const [hearingsZatrzPotr, setHearingsZatrzPotr] = useState(false);
  const [showDate, setShowDate] = useState(false);
  const [showDateId, setShowDateId] = useState("");
  const [results, setResults] = useState([]);

  const getCasesCountDaily = (year, month, day) => {
    var dayBox = "";
    var counter = 0;

    getFilteredHearings().map((el) => {
      var dateSet =
        new Date(el.date).getFullYear() +
        "-" +
        (new Date(el.date).getMonth() + 1) +
        "-" +
        new Date(el.date).getDate();
      var dateCheck = year + "-" + month + "-" + day;
      if (dateSet === dateCheck) {
        counter++;
      }
    });

    return counter;
  };

  const getTasksCountDaily = (year, month, day) => {
    var dayBox = "";
    var counter = 0;

    getFilteredTasks().map((el) => {
      var dateSet =
        new Date(el.final_date).getFullYear() +
        "-" +
        (new Date(el.final_date).getMonth() + 1) +
        "-" +
        new Date(el.final_date).getDate();
      var dateCheck = year + "-" + month + "-" + day;
      if (dateSet === dateCheck) {
        counter++;
      }
    });

    getFilteredSellTasks().map((el) => {
      var dateSet =
        new Date(el.finalDate).getFullYear() +
        "-" +
        (new Date(el.finalDate).getMonth() + 1) +
        "-" +
        new Date(el.finalDate).getDate();
      var dateCheck = year + "-" + month + "-" + day;
      if (dateSet === dateCheck) {
        counter++;
      }
    });

    return counter;
  };

  const addDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() + days);
    return dateN;
  };

  const subDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() - days);
    return dateN;
  };

  const getMonthData = (monthNum) => {
    var data = monthData.filter((el) => +el.id === monthNum);
    return data.length > 0 ? data[0].name : "";
  };

  const getDateOfWeek = (w, y) => {
    var d = 1 + (w - 1) * 7;

    if (new Date(y, 0, d).getFullYear() === 2023) {
      return new Date(y, 0, d + 1);
    } else if (new Date(y, 0, d).getFullYear() === 2024) {
      return new Date(y, 0, d);
    } else if (y === 2025) {
      return subDays(new Date(y, 0, d), 2);
    } else {
      return new Date(y, 0, d);
    }
  };

  const createMonthSet = () => {
    var date = dateC;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var daysArray = [];
    var beginCounter = startMonthDate;
    while (beginCounter >= startMonthDate && beginCounter <= endMonthDate) {
      daysArray.push(
        `${beginCounter.getFullYear()}-${
          beginCounter.getMonth() + 1 < 10
            ? "0" + (beginCounter.getMonth() + 1)
            : beginCounter.getMonth() + 1
        }-${
          beginCounter.getDate() < 10
            ? "0" + beginCounter.getDate()
            : beginCounter.getDate()
        }`
      );
      beginCounter.setDate(beginCounter.getDate() + 1);
    }

    return daysArray;
  };

  const createWeekSet = () => {
    var date = new Date(dateC);

    var dayStart = new Date(date).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;
    var startWeekDate = subDays(date, daysToSubStart);

    var weekArray = [];

    for (var i = 0; i <= 6; ++i) {
      var actualDate = addDays(startWeekDate, i);

      weekArray.push(
        `${actualDate.getFullYear()}-${
          actualDate.getMonth() + 1 < 10
            ? "0" + (actualDate.getMonth() + 1)
            : actualDate.getMonth() + 1
        }-${
          actualDate.getDate() < 10
            ? "0" + actualDate.getDate()
            : actualDate.getDate()
        }`
      );
    }

    return weekArray;
  };

  const createDaySet = () => {
    var date = dateC;
    var dayArray = [];

    dayArray.push(
      `${new Date(date).getFullYear()}-${
        new Date(date).getMonth() + 1 < 10
          ? "0" + (new Date(date).getMonth() + 1)
          : new Date(date).getMonth() + 1
      }-${
        new Date(date).getDate() < 10
          ? "0" + new Date(date).getDate()
          : new Date(date).getDate()
      }`
    );
    return dayArray;
  };

  const fetchHearingsTeam1 = async () => {
    var date = dateC;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var body = {
      dateFrom: startMonthDate,
      dateTo: endMonthDate,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchHearingsTeam2 = async () => {
    var date = dateC;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var body = {
      dateFrom: startMonthDate,
      dateTo: endMonthDate,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchHearingsTeam2Date = async (dateX) => {
    var date = dateX;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var body = {
      dateFrom: startMonthDate,
      dateTo: endMonthDate,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchHearingsAll = async () => {
    var date = dateC;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var body = {
      dateFrom: startMonthDate,
      dateTo: endMonthDate,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsDateAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchHearingsAllDate = async (dateX) => {
    var date = dateX;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var body = {
      dateFrom: startMonthDate,
      dateTo: endMonthDate,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsDateAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchTasksTeam1 = async () => {
    var date = dateC;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var endDateN =
      new Date(endMonthDate).getFullYear() +
      "-" +
      (new Date(endMonthDate).getMonth() + 1 < 10
        ? "0" + (new Date(endMonthDate).getMonth() + 1)
        : new Date(endMonthDate).getMonth() + 1) +
      "-" +
      (new Date(endMonthDate).getDate() < 10
        ? "0" + new Date(endMonthDate).getDate()
        : new Date(endMonthDate).getDate());

    var startDateN =
      new Date(startMonthDate).getFullYear() +
      "-" +
      (new Date(startMonthDate).getMonth() + 1 < 10
        ? "0" + (new Date(startMonthDate).getMonth() + 1)
        : new Date(startMonthDate).getMonth() + 1) +
      "-" +
      (new Date(startMonthDate).getDate() < 10
        ? "0" + new Date(startMonthDate).getDate()
        : new Date(startMonthDate).getDate());

    var body = {
      dateFrom: startDateN,
      dateTo: endDateN,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);

        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchTasksTeam1Date = async (dateX) => {
    var date = dateX;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var endDateN =
      new Date(endMonthDate).getFullYear() +
      "-" +
      (new Date(endMonthDate).getMonth() + 1 < 10
        ? "0" + (new Date(endMonthDate).getMonth() + 1)
        : new Date(endMonthDate).getMonth() + 1) +
      "-" +
      (new Date(endMonthDate).getDate() < 10
        ? "0" + new Date(endMonthDate).getDate()
        : new Date(endMonthDate).getDate());

    var startDateN =
      new Date(startMonthDate).getFullYear() +
      "-" +
      (new Date(startMonthDate).getMonth() + 1 < 10
        ? "0" + (new Date(startMonthDate).getMonth() + 1)
        : new Date(startMonthDate).getMonth() + 1) +
      "-" +
      (new Date(startMonthDate).getDate() < 10
        ? "0" + new Date(startMonthDate).getDate()
        : new Date(startMonthDate).getDate());

    var body = {
      dateFrom: startDateN,
      dateTo: endDateN,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);

        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchSellTasks = async () => {
    var date = dateC;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var endDateN =
      new Date(endMonthDate).getFullYear() +
      "-" +
      (new Date(endMonthDate).getMonth() + 1 < 10
        ? "0" + (new Date(endMonthDate).getMonth() + 1)
        : new Date(endMonthDate).getMonth() + 1) +
      "-" +
      (new Date(endMonthDate).getDate() < 10
        ? "0" + new Date(endMonthDate).getDate()
        : new Date(endMonthDate).getDate());

    var startDateN =
      new Date(startMonthDate).getFullYear() +
      "-" +
      (new Date(startMonthDate).getMonth() + 1 < 10
        ? "0" + (new Date(startMonthDate).getMonth() + 1)
        : new Date(startMonthDate).getMonth() + 1) +
      "-" +
      (new Date(startMonthDate).getDate() < 10
        ? "0" + new Date(startMonthDate).getDate()
        : new Date(startMonthDate).getDate());

    var body = {
      dateFrom: startDateN,
      dateTo: endDateN,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellTasksDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellTasks(getFilteredSellTasksData(data));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchSellTasksDate = async (dateX) => {
    var date = dateX;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var body = {
      dateFrom: startMonthDate,
      dateTo: endMonthDate,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellTasksDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellTasks(getFilteredSellTasksData(data));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTasksTeam2 = async () => {
    var date = dateC;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var body = {
      dateFrom: startMonthDate,
      dateTo: endMonthDate,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);

        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchTasksTeam2Date = async (dateX) => {
    var date = dateX;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var body = {
      dateFrom: startMonthDate,
      dateTo: endMonthDate,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);

        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchTasksAll = async () => {
    var date = dateC;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var body = {
      dateFrom: startMonthDate,
      dateTo: endMonthDate,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksDateAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchTasksAllDate = async (dateX) => {
    var date = dateX;

    var dateStartMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      1
    );

    var dayStart = new Date(dateStartMonth).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;

    var startMonthDate = subDays(dateStartMonth, daysToSubStart);

    var dateEndMonth = new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth() + 1,
      0
    );

    var dayEnd = new Date(dateEndMonth).getDay();
    var daysToAddEnd = 7 - (dayEnd === 0 ? 7 : dayEnd);

    var endMonthDate = addDays(dateEndMonth, daysToAddEnd);

    var body = {
      dateFrom: startMonthDate,
      dateTo: endMonthDate,
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksDateAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
      })
      .catch((error) => {});
  };

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getExpectedResults", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setResults(data);
      })
      .catch((error) => {});
  };

  const getData = (date) => {
    if (props.view === "year") {
      setLoading(true);
      if (props.team === 1) {
        getDataT1ADate(date);
      } else if (props.team === 2) {
        getDataT2ADate(date);
      } else if (props.team === 0) {
        getDataAAllDate(date);
      }
    } else {
      setLoading(true);
      if (props.team === 1) {
        getDataT1Date(date);
      } else if (props.team === 2) {
        getDataT2Date(date);
      } else if (props.team === 0) {
        getDataAllDate(date);
      }
    }
  };

  const getDataT1 = () => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsTeam1();
    fetchTasksTeam1();
    fetchSellTasks();
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date(date).getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + weekNumber);
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
    return 1;
  };

  const getDataT1Date = (dateX) => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsTeam1ADate(dateX);
    fetchTasksTeam1Date(dateX);
    fetchSellTasksDate(dateX);
    var date = dateX;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date(date).getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + weekNumber);
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
  };

  const getDataT2 = () => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsTeam2();
    fetchTasksTeam2();
    fetchSellTasks();
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
  };

  const getDataT2Date = (dateX) => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsTeam2Date(dateX);
    fetchTasksTeam2Date(dateX);
    fetchSellTasksDate(dateX);
    var date = dateX;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
  };

  const getDataAll = () => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsAll();
    fetchTasksAll();
    fetchSellTasks();
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
  };

  const getDataAllDate = (dateX) => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsAllDate(dateX);
    fetchTasksAllDate(dateX);
    fetchSellTasksDate(dateX);
    var date = dateX;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
  };

  useEffect(() => {
    var test = 0;
    if (props.view === "year") {
      setLoading(true);
      if (props.team === 1) {
        setInterval(() => {
          if (test === 0) {
            setLoading(true);
            test = getDataT1A();
          }
        }, 2000);
      } else if (props.team === 2) {
        setInterval(() => {
          if (test === 0) {
            setLoading(true);
            test = getDataT2A();
          }
        }, 2000);
      } else if (props.team === 0) {
        setInterval(() => {
          if (test === 0) {
            setLoading(true);
            test = getDataAAll();
          }
        }, 2000);
      }
    } else {
      setLoading(true);
      if (props.team === 1) {
        setInterval(() => {
          if (test === 0) {
            setLoading(true);
            test = getDataT1();
          }
        }, 2000);
      } else if (props.team === 2) {
        setInterval(() => {
          if (test === 0) {
            setLoading(true);
            test = getDataT2();
          }
        }, 2000);
      } else if (props.team === 0) {
        setInterval(() => {
          if (test === 0) {
            setLoading(true);
            test = getDataAll();
          }
        }, 2000);
      }
    }
  }, []);

  const showDatePopUp = (e) => {
    setShowDateId(e.currentTarget.value);
    setShowDate(true);
  };

  const createHearingButtonMonth = (hearing, date) => {
    var dateH = new Date(hearing.date);
    var dateR = new Date(date);

    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            key={hearing.id}
            style={
              hearing.clientType === "sankcja kredytu darmowego"
                ? { backgroundColor: "#349eeb" }
                : hearing.result === "Odwołana z nowym terminem" ||
                  hearing.result === "Odwołana bez terminu"
                ? { backgroundColor: "#757573" }
                : hearing.subject === "Ogłoszenie wyroku"
                ? { backgroundColor: "#7db541" }
                : hearing.subject === "Spotkanie mediacyjne"
                ? { backgroundColor: "#5287ab" }
                : hearing.form === "online"
                ? { backgroundColor: "#e3a74b" }
                : { backgroundColor: "#0b315f" }
            }
            key={hearing.id}
            id="monthLink"
            className="caseLink"
            value={hearing.id}
            onClick={showDatePopUp}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {hearing.clientType === "sankcja kredytu darmowego"
                  ? "(SKD) "
                  : ""}
                {hearing.name.split(",").map((el) => (
                  <>
                    {el}
                    <br />
                  </>
                ))}{" "}
                {getInitials(hearing.lawyer)}
              </div>
              <div className="titleBox_col2">
                {" "}
                {hearing.accepted === "yes" ? (
                  <span id="calendar_check" className="highlight_blue">
                    ✓
                  </span>
                ) : (
                  ""
                )}
                {hearing.status === "SPRAWDZONO" ? (
                  <span id="calendar_check" className="highlight_green">
                    ✓
                  </span>
                ) : (
                  ""
                )}
                {hearing.arch === "1" ? (
                  <span id="calendar_check" className="highlight_green">
                    ✓
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </button>{" "}
        </>
      );
    }
  };

  const getInitials = (user) => {
    var newData = users.filter((el) => el.name === user);
    if (newData.length > 0) {
      return newData[0].initials;
    } else {
      return "";
    }
  };

  const createTaskButtonMonth = (task, date) => {
    var dateH = new Date(task.final_date);
    var dateR = new Date(date);
    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            key={task.id}
            id={
              task.status === "WYKONANE"
                ? "monthLinkTaskDone"
                : task.type === "POZASĄDOWE"
                ? "weekLinkTaskNoCourt"
                : task.responsible !== ""
                ? "monthLinkTaskUser"
                : "monthLinkTask"
            }
            className="caseLink"
            value={task.id}
            onClick={props.showTaskPopUp}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {task.task + " " + getInitials(task.responsible)}
              </div>
              <div className="titleBox_col2"></div>
            </div>
          </button>{" "}
        </>
      );
    }
  };

  const createSellTaskButtonMonth = (task, date) => {
    var dateH = new Date(task.finalDate);
    var dateR = new Date(date);
    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            style={
              task.status === "WYKONANE"
                ? { backgroundColor: "green", color: "white" }
                : { backgroundColor: "#ccdcfc", color: "black" }
            }
            key={task.id}
            id={
              task.status === "WYKONANE"
                ? "monthLinkTaskDone"
                : task.type === "POZASĄDOWE"
                ? "weekLinkTaskNoCourt"
                : task.responsible !== ""
                ? "monthLinkTaskUser"
                : "monthLinkTask"
            }
            className="caseLink"
            value={task.id}
            onClick={props.showSellTaskPopUp}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {task.task + " " + getInitials(task.responsible)}
              </div>
              <div className="titleBox_col2"></div>
            </div>
          </button>{" "}
        </>
      );
    }
  };

  const createHearingButtonWeek = (hearing, date) => {
    var dateH = new Date(hearing.date);
    var dateR = new Date(date);
    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            style={
              hearing.clientType === "sankcja kredytu darmowego"
                ? { backgroundColor: "#349eeb" }
                : hearing.result === "Odwołana z nowym terminem" ||
                  hearing.result === "Odwołana bez terminu"
                ? { backgroundColor: "#757573" }
                : hearing.subject === "Ogłoszenie wyroku"
                ? { backgroundColor: "#7db541" }
                : hearing.subject === "Spotkanie mediacyjne"
                ? { backgroundColor: "#5287ab" }
                : hearing.form === "online"
                ? { backgroundColor: "#e3a74b" }
                : { backgroundColor: "#0b315f" }
            }
            key={hearing.id}
            id="weekLink"
            className="caseLink"
            value={hearing.id}
            onClick={props.showDatePopUp}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {hearing.clientType === "sankcja kredytu darmowego"
                  ? "(SKD) "
                  : ""}{" "}
                {hearing.name} {getInitials(hearing.lawyer)}
              </div>
              <div className="titleBox_col2">
                {hearing.accepted === "yes" ? (
                  <span id="calendar_check" className="highlight_blue">
                    ✓
                  </span>
                ) : (
                  ""
                )}
                {hearing.status === "SPRAWDZONO" ? (
                  <span id="calendar_check" className="highlight_green">
                    ✓
                  </span>
                ) : (
                  ""
                )}
                {hearing.arch === "1" ? (
                  <span id="calendar_check" className="highlight_green">
                    ✓
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </button>{" "}
        </>
      );
    }
  };

  const createHearingButtonDay = (hearing, date) => {
    var dateH = new Date(hearing.date);
    var dateR = new Date(date);
    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            style={
              hearing.clientType === "sankcja kredytu darmowego"
                ? { backgroundColor: "#349eeb" }
                : hearing.result === "Odwołana z nowym terminem" ||
                  hearing.result === "Odwołana bez terminu"
                ? { backgroundColor: "#757573" }
                : hearing.subject === "Ogłoszenie wyroku"
                ? { backgroundColor: "#7db541" }
                : hearing.subject === "Spotkanie mediacyjne"
                ? { backgroundColor: "#5287ab" }
                : hearing.form === "online"
                ? { backgroundColor: "#e3a74b" }
                : { backgroundColor: "#0b315f" }
            }
            key={hearing.id}
            id="dayLink"
            className="caseLink"
            value={hearing.id}
            onClick={props.showDatePopUp}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {hearing.clientType === "sankcja kredytu darmowego"
                  ? "(SKD) "
                  : ""}{" "}
                {hearing.name} {getInitials(hearing.lawyer)}
              </div>
              <div className="titleBox_col2">
                {hearing.accepted === "yes" ? (
                  <span id="calendar_check" className="highlight_blue">
                    ✓
                  </span>
                ) : (
                  ""
                )}
                {hearing.status === "SPRAWDZONO" ? (
                  <span id="calendar_check" className="highlight_green">
                    ✓
                  </span>
                ) : (
                  ""
                )}
                {hearing.arch === "1" ? (
                  <span id="calendar_check" className="highlight_green">
                    ✓
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </button>{" "}
        </>
      );
    }
  };

  const createTaskButtonWeek = (task, date) => {
    var dateH = new Date(task.final_date);
    var dateR = new Date(date);
    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            key={task.id}
            id={
              task.status === "WYKONANE"
                ? "weekLinkTaskDone"
                : task.type === "POZASĄDOWE"
                ? "weekLinkTaskNoCourt"
                : task.responsible !== ""
                ? "weekLinkTaskUser"
                : "weekLinkTask"
            }
            className="caseLink"
            value={task.id}
            onClick={props.showTaskPopUp}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {task.task + " " + getInitials(task.responsible)}
              </div>
              <div className="titleBox_col2"></div>
            </div>
          </button>
        </>
      );
    }
  };

  const createSellTaskButtonWeek = (task, date) => {
    var dateH = new Date(task.finalDate);
    var dateR = new Date(date);
    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            style={
              task.status === "WYKONANE"
                ? { backgroundColor: "green", color: "white" }
                : { backgroundColor: "#ccdcfc", color: "black" }
            }
            key={task.id}
            id={
              task.status === "WYKONANE"
                ? "weekLinkTaskDone"
                : task.type === "POZASĄDOWE"
                ? "weekLinkTaskNoCourt"
                : task.responsible !== ""
                ? "weekLinkTaskUser"
                : "weekLinkTask"
            }
            className="caseLink"
            value={task.id}
            onClick={props.showSellTaskPopUp}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {task.task + " " + getInitials(task.responsible)}
              </div>
              <div className="titleBox_col2"></div>
            </div>
          </button>{" "}
        </>
      );
    }
  };

  const createTaskButtonDay = (task, date) => {
    var dateH = new Date(task.final_date);
    var dateR = new Date(date);
    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            key={task.id}
            id={
              task.status === "WYKONANE"
                ? "dayLinkTaskDone"
                : task.type === "POZASĄDOWE"
                ? "dayLinkTaskNoCourt"
                : task.responsible !== ""
                ? "dayLinkTaskUser"
                : "dayLinkTask"
            }
            className="caseLink"
            value={task.id}
            onClick={props.showTaskPopUp}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {task.task + " " + getInitials(task.responsible)}
              </div>
              <div className="titleBox_col2"></div>
            </div>
          </button>{" "}
        </>
      );
    }
  };

  const createSellTaskButtonDay = (task, date) => {
    var dateH = new Date(task.finalDate);
    var dateR = new Date(date);
    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            style={
              task.status === "WYKONANE"
                ? { backgroundColor: "green", color: "white" }
                : { backgroundColor: "#ccdcfc", color: "black" }
            }
            key={task.id}
            id={
              task.status === "WYKONANE"
                ? "dayLinkTaskDone"
                : task.type === "POZASĄDOWE"
                ? "dayLinkTaskNoCourt"
                : task.responsible !== ""
                ? "dayLinkTaskUser"
                : "dayLinkTask"
            }
            className="caseLink"
            value={task.id}
            onClick={props.showSellTaskPopUp}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {task.task + " " + getInitials(task.responsible)}
              </div>
              <div className="titleBox_col2"></div>
            </div>
          </button>{" "}
        </>
      );
    }
  };

  const getDataT1A = () => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsTeam1A();
    fetchTasksTeam1A();
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
    return 1;
  };

  const getDataT1ADate = (dateX) => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsTeam1ADate(dateX);
    fetchTasksTeam1ADate(dateX);
    var date = dateX;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
  };

  const fetchHearingsTeam1A = async () => {
    var body = {
      month: new Date(props.date).getMonth() + 1,
      year: new Date(props.date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchHearingsTeam1ADate = async (date) => {
    var body = {
      month: new Date(date).getMonth() + 1,
      year: new Date(date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchHearingsTeam2A = async () => {
    var body = {
      month: new Date(props.date).getMonth() + 1,
      year: new Date(props.date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchHearingsTeam2ADate = async (date) => {
    var body = {
      month: new Date(date).getMonth() + 1,
      year: new Date(date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchHearingsAAll = async () => {
    var body = {
      month: new Date(props.date).getMonth() + 1,
      year: new Date(props.date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsYearAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchHearingsAAllDate = async (date) => {
    var body = {
      month: new Date(date).getMonth() + 1,
      year: new Date(date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsYearAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        data = getAllowedClients(data);
        setHearings(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchTasksTeam1A = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTasksTeam1ADate = async (date) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTasksTeam2A = async () => {
    var body = {
      month: new Date(props.date).getMonth() + 1,
      year: new Date(props.date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTasksTeam2ADate = async (date) => {
    var body = {
      month: new Date(date).getMonth() + 1,
      year: new Date(date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksYear", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);
        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTasksAAll = async () => {
    var body = {
      month: new Date(props.date).getMonth() + 1,
      year: new Date(props.date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksYearAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);

        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTasksAAllDate = async (date) => {
    var body = {
      month: new Date(date).getMonth() + 1,
      year: new Date(date).getFullYear(),
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksYearAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data);

        setTasks(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const checkAllowed = (allowed, data) => {
    allowed.map((el) => {
      if (+el === +data.clientId) {
        return true;
      }
    });
    return false;
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      //var sub =
      //  props.substitutes.filter((el) => +el.userId === +props.user.id).length >
      //  0
      //    ? props.substitutes.filter((el) => +el.userId === +props.user.id)[0]
      //        .name
      //    : "";

      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];

      //allowed.map((el) => {
      //  arr = arr.concat(
      //    data.filter(
      //      (el2) => +el2.clientId === +el || el2.substitute_name === sub
      //    )
      //  );
      //});
      allowed.map((x) => {
        if (x !== "") {
          arr = arr.concat(
            data.filter(
              (y) =>
                +y.clientId === +x ||
                (y.lawyer !== undefined
                  ? y.lawyer === props.user.name
                  : y.responsible !== undefined
                  ? y.responsible === props.user.name
                  : false)
            )
          );
        }
      });

      return arr;
    }
  };

  const getDataT2A = () => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsTeam2A();
    fetchTasksTeam2A();
    fetchSellTasks();
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
  };

  const getDataT2ADate = (dateX) => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsTeam2ADate(dateX);
    fetchTasksTeam2ADate(dateX);
    fetchSellTasksDate(dateX);
    var date = dateX;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
  };

  const getDataAAllDate = (dateX) => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsAAllDate(dateX);
    fetchTasksAAllDate(dateX);
    fetchSellTasksDate(dateX);
    var date = dateX;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
  };

  const getDataAAll = () => {
    setLoading(true);
    fetchUsers();
    fetchResults();
    fetchHearingsAAll();
    fetchTasksAAll();
    fetchSellTasks();
    var date = dateC;
    var year = new Date(date).getFullYear();
    var month = new Date(date).getMonth() + 1;
    var day = new Date(date).getDate();
    var end = new Date(year, month, 0);
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
    setYearName("Rok " + year);
    setDayName("Dzień " + year + "-" + month + "-" + day);
    setMonthName(getMonthData(month) + " " + year);
    setMonthNameDisabled(getMonthData(month));
  };

  const getMonthDataForYearCalendar = (month) => {
    var year = new Date(dateC).getFullYear();

    var hearingsHouse = hearings.filter(
      (el) =>
        new Date(el.date).getFullYear() === year &&
        new Date(el.date).getMonth() + 1 === month &&
        el.form === "stacjonarna"
    );
    var hearingsOnline = hearings.filter(
      (el) =>
        new Date(el.date).getFullYear() === year &&
        new Date(el.date).getMonth() + 1 === month &&
        el.form === "online"
    );
    var tasksA = tasks.filter(
      (el) =>
        new Date(el.final_date).getFullYear() === year &&
        new Date(el.final_date).getMonth() + 1 === month
    );

    var toReturn = (
      <>
        <p className="monthYearData">
          Rozprawy stacjonarne:{" "}
          {hearingsHouse === undefined ? 0 : hearingsHouse.length}
        </p>
        <p className="monthYearData">
          Rozprawy online:{" "}
          {hearingsOnline === undefined ? 0 : hearingsOnline.length}
        </p>
        <p className="monthYearData">
          Zadania: {tasksA === undefined ? 0 : tasksA.length}
        </p>
      </>
    );

    return toReturn;
  };

  const scrollBox = (e) => {
    const divToScrollTo = document.getElementById("cb" + e.target.value);
    divToScrollTo.scrollTo({
      top: divToScrollTo.scrollTop + 100,
      behavior: "smooth",
    });
  };

  const getFilteredHearings = () => {
    var arrHearings = props.hearingsCalendar ? hearings : [];

    if (props.userCalendar.length > 0 && props.hearingsCalendar) {
      arrHearings = arrHearings.filter(
        (el) =>
          el.lawyer === props.userCalendar ||
          (props.userCalendar === "none" && el.lawyer.length === 0)
      );
    }

    if (props.resultFilter.length > 0) {
      arrHearings = arrHearings.filter(
        (el) => el.result === props.resultFilter
      );
    }

    if (props.caseTypeFilter.length > 0) {
      arrHearings = arrHearings.filter(
        (el) => el.subject === props.caseTypeFilter
      );
    }

    if (props.caseFormFilter.length > 0) {
      arrHearings = arrHearings.filter(
        (el) => el.form === props.caseFormFilter
      );
    }

    if (props.courtFilter.length > 0) {
      arrHearings = arrHearings.filter((el) => el.court === props.courtFilter);
    }

    if (props.tasksNoClientFilter) {
      arrHearings = arrHearings.filter((el) => el.clientId === "");
    }

    if (props.clientTypeFilter.length > 0) {
      if (props.clientTypeFilter !== "all") {
        arrHearings = arrHearings.filter(
          (el) => el.clientType === props.clientTypeFilter
        );
      }
    }

    if (hearingsZatrzPotr) {
      arrHearings = arrHearings.filter((el) => el.zatrz_potr === "TAK");
    }

    if (hearingsPotrCl) {
      arrHearings = arrHearings.filter((el) => el.potrCl === "TAK");
    }

    if (teorSald) {
      arrHearings = arrHearings.filter((el) => el.sts === "TAK");
    }

    return arrHearings;
  };

  const getFilteredHearingsData = (data) => {
    var arrHearings = data;

    if (props.userCalendar.length > 0 && props.hearingsCalendar) {
      arrHearings = arrHearings.filter(
        (el) =>
          el.lawyer === props.userCalendar ||
          (props.userCalendar === "none" && el.lawyer.length === 0)
      );
    }

    if (props.resultFilter.length > 0) {
      arrHearings = arrHearings.filter(
        (el) => el.result === props.resultFilter
      );
    }

    if (props.caseTypeFilter.length > 0) {
      arrHearings = arrHearings.filter(
        (el) => el.subject === props.caseTypeFilter
      );
    }

    if (props.caseFormFilter.length > 0) {
      arrHearings = arrHearings.filter(
        (el) => el.form === props.caseFormFilter
      );
    }

    if (props.courtFilter.length > 0) {
      arrHearings = arrHearings.filter((el) => el.court === props.courtFilter);
    }

    if (props.tasksNoClientFilter) {
      arrHearings = arrHearings.filter((el) => el.clientId === "");
    }

    if (props.clientTypeFilter.length > 0) {
      if (props.clientTypeFilter !== "all") {
        arrHearings = arrHearings.filter(
          (el) => el.clientType === props.clientTypeFilter
        );
      }
    }

    if (hearingsZatrzPotr) {
      arrHearings = arrHearings.filter((el) => el.zatrz_potr === "TAK");
    }

    if (hearingsPotrCl) {
      arrHearings = arrHearings.filter((el) => el.potrCl === "TAK");
    }

    if (teorSald) {
      arrHearings = arrHearings.filter((el) => el.sts === "TAK");
    }

    return arrHearings;
  };

  const getFilteredTasks = () => {
    var arrTasks = props.tasksCalendar ? tasks : [];

    if (props.userCalendar.length > 0) {
      arrTasks = arrTasks.filter(
        (el) =>
          el.responsible === props.userCalendar ||
          (props.userCalendar === "none" && el.responsible.length === 0)
      );
    }

    arrTasks = arrTasks.filter(
      (el) =>
        (props.tasksComissioned && el.status === "ZLECONE") ||
        (props.tasksComissioned && el.status === "ZAPLANOWANE") ||
        (props.tasksFinalized && el.status === "WYKONANE")
    );

    arrTasks = arrTasks.filter(
      (el) =>
        (props.tasksCourtFilter && el.type === "SĄDOWE") ||
        (props.tasksNoCourtFilter && el.type === "POZASĄDOWE")
    );

    if (props.taskTypeFilter.length > 0) {
      arrTasks = arrTasks.filter(
        (el) => el.task.replaceAll(" - SKD", "") === props.taskTypeFilter
      );
    }

    if (props.user.role !== "admin" && props.user.allowedClients === "all") {
      arrTasks = arrTasks.filter((el) => el.responsible === props.user.name);
    }

    if (props.clientTypeFilter.length > 0) {
      if (props.clientTypeFilter !== "all") {
        arrTasks = arrTasks.filter(
          (el) => el.clientType === props.clientTypeFilter
        );
      }
    }

    if (teorSald) {
      arrTasks = arrTasks.filter((el) => el.sts === "TAK");
    }

    return arrTasks;
  };

  const getFilteredTasksData = (data) => {
    var arrTasks = data;

    if (props.userCalendar.length > 0) {
      arrTasks = arrTasks.filter(
        (el) =>
          el.responsible === props.userCalendar ||
          (props.userCalendar === "none" && el.responsible.length === 0)
      );
    }

    arrTasks = arrTasks.filter(
      (el) =>
        (props.tasksComissioned && el.status === "ZLECONE") ||
        (props.tasksComissioned && el.status === "ZAPLANOWANE") ||
        (props.tasksFinalized && el.status === "WYKONANE")
    );

    arrTasks = arrTasks.filter(
      (el) =>
        (props.tasksCourtFilter && el.type === "SĄDOWE") ||
        (props.tasksNoCourtFilter && el.type === "POZASĄDOWE")
    );

    if (props.taskTypeFilter.length > 0) {
      arrTasks = arrTasks.filter(
        (el) => el.task.replaceAll(" - SKD", "") === props.taskTypeFilter
      );
    }

    if (props.user.role !== "admin" && props.user.allowedClients === "all") {
      arrTasks = arrTasks.filter((el) => el.responsible === props.user.name);
    }

    if (props.clientTypeFilter.length > 0) {
      if (props.clientTypeFilter !== "all") {
        arrTasks = arrTasks.filter(
          (el) => el.clientType === props.clientTypeFilter
        );
      }
    }

    if (teorSald) {
      arrTasks = arrTasks.filter((el) => el.sts === "TAK");
    }

    return arrTasks;
  };

  const getFilteredSellTasks = () => {
    var arrTasks = sellTasks;

    if (props.userCalendar.length > 0 && props.user.adminSprzedaz === "1") {
      arrTasks = arrTasks.filter((el) => el.responsible === props.userCalendar);
    }

    if (props.user.adminSprzedaz !== "1") {
      arrTasks = arrTasks.filter((el) => el.responsible === props.user.name);
    }

    if (!props.tasksSell) {
      arrTasks = [];
    }

    return arrTasks;
  };

  const getFilteredSellTasksData = (data) => {
    var arrTasks = data;

    if (props.userCalendar.length > 0 && props.user.adminSprzedaz === "1") {
      arrTasks = arrTasks.filter((el) => el.responsible === props.userCalendar);
    }

    if (props.user.adminSprzedaz !== "1") {
      arrTasks = arrTasks.filter((el) => el.responsible === props.user.name);
    }

    if (!props.tasksSell) {
      arrTasks = [];
    }

    return arrTasks;
  };

  const calendarMonthNew = (
    <>
      <div className="rowCalendar">
        {createMonthSet().map((el) => (
          <div key={el} className="cellCalendar">
            <div id={"cb" + new Date(el).getDate()} className="cellBox">
              <div id="mainCalendarBox">
                {getFilteredHearings().map((el2) => (
                  <>{createHearingButtonMonth(el2, el)}</>
                ))}
                {getFilteredTasks().map((el2) => (
                  <>{createTaskButtonMonth(el2, el)}</>
                ))}
                {getFilteredSellTasks().map((el2) => (
                  <>{createSellTaskButtonMonth(el2, el)}</>
                ))}
              </div>
            </div>
            {getCasesCountDaily(
              new Date(el).getFullYear(),
              new Date(el).getMonth() + 1,
              new Date(el).getDate()
            ) +
              getTasksCountDaily(
                new Date(el).getFullYear(),
                new Date(el).getMonth() + 1,
                new Date(el).getDate()
              ) >
            3 ? (
              <button
                value={new Date(el).getDate()}
                onClick={scrollBox}
                className="moreButtonCalendar"
              >
                ▼
              </button>
            ) : (
              ""
            )}
            <span className="cellDayNumber">
              <button
                className="dailyButton"
                value={el}
                onClick={props.setViewDay}
              >
                WIDOK DZIENNY
              </button>
              <span className="quantityCell">
                T:{" "}
                {getCasesCountDaily(
                  new Date(el).getFullYear(),
                  new Date(el).getMonth() + 1,
                  new Date(el).getDate()
                )}{" "}
                Z:{" "}
                {getTasksCountDaily(
                  new Date(el).getFullYear(),
                  new Date(el).getMonth() + 1,
                  new Date(el).getDate()
                )}
              </span>{" "}
              {new Date(el).getDate()}
            </span>
          </div>
        ))}
      </div>
    </>
  );

  const goToMonthViewYear = (e) => {
    e.preventDefault();
    if (e.currentTarget.value === undefined) {
      return;
    }
    var year = new Date(dateC).getFullYear();
    var newDate = `${year}-${+e.currentTarget.value}-01`;
    props.setForYear(new Date(newDate));
  };
  const handleReportChange = (e) => {
    setShowReportPopUp(true);
    setMonthId(e.target.value);
  };

  const closeReport = (e) => {
    setShowReportPopUp(false);
    setMonthId("");
  };

  const calendarYearNew = (
    <>
      <div className="rowCalendar">
        {props.monthData.map((el) => (
          <>
            <div key={el} className="yearBoxView">
              <button
                className="colYearCalendar"
                value={+el.id}
                onClick={goToMonthViewYear}
              >
                <>
                  <div className="monthTitle">{el.name}</div>
                  <div className="monthYearContent">
                    {getMonthDataForYearCalendar(+el.id)}
                  </div>
                </>
              </button>
              {props.user.role === "admin" ? (
                <button
                  className="yearReportButton"
                  value={el.id}
                  onClick={handleReportChange}
                >
                  RAPORT
                </button>
              ) : (
                ""
              )}
            </div>
          </>
        ))}
      </div>
    </>
  );

  const calendarWeekNew = (
    <>
      <div className="rowCalendar">
        {createWeekSet().map((el) => (
          <>
            <div key={el} className="colWeekCalendar">
              <div className="weekContent">
                <p className="colWeekTitle">
                  {new Date(el).getFullYear()}-
                  {new Date(el).getMonth() + 1 < 10
                    ? "0" + (new Date(el).getMonth() + 1)
                    : new Date(el).getMonth() + 1}
                  -
                  {new Date(el).getDate() < 10
                    ? "0" + new Date(el).getDate()
                    : new Date(el).getDate()}
                </p>
                {getFilteredHearings().map((el2) => (
                  <>{createHearingButtonWeek(el2, el)}</>
                ))}
                {getFilteredTasks().map((el2) => (
                  <>{createTaskButtonWeek(el2, el)}</>
                ))}
                {getFilteredSellTasks().map((el2) => (
                  <>{createSellTaskButtonWeek(el2, el)}</>
                ))}
              </div>
              <div className="weekButton">
                <button
                  className="dailyButtonWeek"
                  value={el}
                  onClick={props.setViewDay}
                >
                  WIDOK DZIENNY
                </button>
              </div>
            </div>
          </>
        ))}
      </div>
    </>
  );

  const calendarDailyNew = (
    <>
      <div className="rowCalendar">
        {createDaySet().map((el) => (
          <>
            <div key={el} className="colDayCalendar">
              {getFilteredHearings().map((el2) => (
                <>{createHearingButtonDay(el2, el)}</>
              ))}
              {getFilteredTasks().map((el2) => (
                <>{createTaskButtonDay(el2, el)}</>
              ))}
              {getFilteredSellTasks().map((el2) => (
                <>{createSellTaskButtonDay(el2, el)}</>
              ))}
            </div>
          </>
        ))}
      </div>
    </>
  );

  const handleCalendarUserChange = (e) => {
    props.setUserCalendar(e);
  };

  const handleResultFilterChange = (e) => {
    props.setResultFilter(e);
  };

  const handleCaseTypeFilterChange = (e) => {
    props.setCaseTypeFilter(e);
  };

  const handleCaseFormFilterChange = (e) => {
    props.setCaseFormFilter(e);
  };

  const handleCourtFilterChange = (e) => {
    props.setCourtFilter(e);
  };

  const handleTaskTypeFilterChange = (e) => {
    props.setTaskTypeFilter(e);
  };

  const handleClientTypeFilterChange = (e) => {
    props.setClientTypeFilter(e);
  };

  const handleExpandFiltersClick = (e) => {
    setExpandFilters(!expandFilters);
  };

  const clearFilters = (e) => {
    props.clearFilters();
    setExpandFilters(!expandFilters);
  };

  const getUsersForTeam = (e) => {
    var usersForTeam = [];

    users.map((el) => {
      if (el.team.split(",").filter((el2) => +el2 === props.team).length > 0) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const subtractMonths = (numOfMonths) => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() - numOfMonths));

    setDateC(retDate);
    return retDate;
  };

  const addMonths = (numOfMonths) => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setDate(1));
    retDate = new Date(retDate.setMonth(retDate.getMonth() + numOfMonths));

    setDateC(retDate);
    return retDate;
  };

  const subtractWeek = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 6));

    setDateC(retDate);
    return retDate;
  };

  const addWeek = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 6));

    setDateC(retDate);
    return retDate;
  };

  const subtractQuarter = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() - 3));

    setDateC(retDate);
    return retDate;
  };

  const addYear = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setYear(newDate.getFullYear() + 1));

    setDateC(retDate);
    return retDate;
  };

  const addDay = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));

    setDateC(retDate);
    return retDate;
  };

  const subtractYear = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setYear(newDate.getFullYear() - 1));

    setDateC(retDate);
    return retDate;
  };

  const subtractDay = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 1));

    setDateC(retDate);
    return retDate;
  };

  const addQuarter = () => {
    var newDate = new Date(dateC);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() + 3));
    setDateC(retDate);
    return retDate;
  };

  const setDate = (e) => {
    setLoading(true);
    var date = "";
    if (e.target.value === "next") {
      if (props.view === "month") {
        date = addMonths(1);
      } else if (props.view === "week") {
        date = addWeek();
      } else if (props.view === "quarter") {
        date = addQuarter();
      } else if (props.view === "year") {
        date = addYear();
      } else if (props.view === "daily") {
        date = addDay();
      }
    } else if (e.target.value === "previous") {
      if (props.view === "month") {
        date = subtractMonths(1);
      } else if (props.view === "week") {
        date = subtractWeek();
      } else if (props.view === "quarter") {
        date = subtractQuarter();
      } else if (props.view === "year") {
        date = subtractYear();
      } else if (props.view === "daily") {
        date = subtractDay();
      }
    }

    getData(date);
  };

  const desktopFilters = (
    <>
      <div className="navigationCalendar">
        <>
          <div className="sectionTitleCalendar">
            {props.view === "month"
              ? monthName
              : props.view === "week"
              ? weekName
              : props.view === "year"
              ? yearName
              : props.view === "daily"
              ? dayName
              : ""}
          </div>
          <button
            className="navigationArrow"
            value="previous"
            onClick={setDate}
          >
            &#8592;
          </button>
          <button className="navigationArrow" value="next" onClick={setDate}>
            &#8594;
          </button>
          {props.view === "year" ? (
            ""
          ) : props.user.role === "admin" ? (
            <>
              <select
                type="text"
                id="selectShowRecords"
                name="signature"
                value={props.userCalendar}
                onChange={handleCalendarUserChange}
              >
                <option key="0" value="">
                  Wszystkie
                </option>
                <option key="1" value="none">
                  Nieprzypisane
                </option>
                {getUsersForTeam().map((el) => (
                  <option key={el.name} value={el.name}>
                    {el.name}
                  </option>
                ))}
              </select>
            </>
          ) : props.userCalendar.length === 0 ? (
            <button
              className="calendarUserButton"
              value={props.user.name}
              onClick={handleCalendarUserChange}
            >
              POKAŻ TYLKO MOJE REKORDY
            </button>
          ) : (
            <button
              className="calendarUserButton"
              value={""}
              onClick={handleCalendarUserChange}
            >
              POKAŻ WSZYSTKIE REKORDY
            </button>
          )}
          {props.view === "year" ? (
            ""
          ) : (
            <>
              <div className="checkBox">
                <input
                  id="checkCal"
                  type="checkbox"
                  checked={props.hearingsCalendar}
                  onChange={props.setHearingsCalendar}
                />
                ROZPRAWY
              </div>
              <div className="checkBox">
                <input
                  id="checkCal"
                  type="checkbox"
                  checked={props.tasksCalendar}
                  onChange={props.setTasksCalendar}
                />
                ZADANIA
              </div>
              {props.tasksCalendar ? (
                <>
                  <div className="subCheckboxes">
                    <div className="checkBox">
                      <input
                        id="checkCal"
                        type="checkbox"
                        checked={props.tasksComissioned}
                        onChange={props.setTasksComissioned}
                      />
                      zlecone
                    </div>
                    <div className="checkBox">
                      <input
                        id="checkCal"
                        type="checkbox"
                        checked={props.tasksFinalized}
                        onChange={props.setTasksFinalized}
                      />
                      wykonane
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="checkBox">
                <input
                  id="checkCal"
                  type="checkbox"
                  checked={props.tasksSell}
                  onChange={props.setTasksSell}
                />
                KONTAKTY
              </div>
            </>
          )}
        </>
      </div>
    </>
  );

  const handleExpandMobileChange = () => {
    setExpandMobileFilters(!expandMobileFilters);
  };

  const mobileFilters = (
    <>
      <div
        style={
          expandMobileFilters
            ? { display: "flex", width: "100%", padding: "1vh 0" }
            : { display: "flex", width: "100%", padding: "3vh 0" }
        }
      >
        <div style={{ width: "100%" }}>
          <button
            className="calendarUserButton"
            style={{ width: "100%", justifyContent: "center" }}
            value={props.user.name}
            onClick={handleExpandMobileChange}
          >
            {!expandMobileFilters ? "ROZWIŃ FILTRY" : "ZWIŃ FILTRY"}
          </button>
        </div>
      </div>
      {expandMobileFilters ? (
        <>
          <div className="navigationCalendar">
            <>
              <div className="navCalendar">
                <div className="sectionTitleCalendar">
                  {props.view === "month"
                    ? monthName
                    : props.view === "week"
                    ? weekName
                    : props.view === "year"
                    ? yearName
                    : props.view === "daily"
                    ? dayName
                    : ""}
                </div>
                <button
                  className="navigationArrow"
                  value="previous"
                  onClick={props.setDate}
                >
                  &#8592;
                </button>
                <button
                  className="navigationArrow"
                  value="next"
                  onClick={props.setDate}
                >
                  &#8594;
                </button>
              </div>
              {props.view === "year" ? (
                ""
              ) : props.user.role === "admin" ? (
                <>
                  <div className="selFilters">
                    <select
                      type="text"
                      id="selectShowRecords"
                      name="signature"
                      value={props.userCalendar}
                      onChange={handleCalendarUserChange}
                    >
                      <option key="0" value="">
                        Wszystkie
                      </option>
                      <option key="1" value="none">
                        Nieprzypisane
                      </option>
                      {getUsersForTeam().map((el) => (
                        <option key={el.name} value={el.name}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              ) : props.userCalendar.length === 0 ? (
                <div className="selFilters">
                  <button
                    className="calendarUserButton"
                    value={props.user.name}
                    onClick={handleCalendarUserChange}
                  >
                    POKAŻ TYLKO MOJE REKORDY
                  </button>
                </div>
              ) : (
                <div className="selFilters">
                  <button
                    className="calendarUserButton"
                    value={""}
                    onClick={handleCalendarUserChange}
                  >
                    POKAŻ WSZYSTKIE REKORDY
                  </button>
                </div>
              )}
              {props.view === "year" ? (
                ""
              ) : (
                <>
                  <div className="checkBox">
                    <input
                      id="checkCal"
                      type="checkbox"
                      style={{ width: "20px" }}
                      checked={props.hearingsCalendar}
                      onChange={props.setHearingsCalendar}
                    />
                    ROZPRAWY
                  </div>
                  <div className="checkBox">
                    <input
                      id="checkCal"
                      type="checkbox"
                      style={{ width: "20px" }}
                      checked={props.tasksCalendar}
                      onChange={props.setTasksCalendar}
                    />
                    ZADANIA
                  </div>
                  {props.tasksCalendar ? (
                    <>
                      <div className="subCheckboxes">
                        <div className="checkBox">
                          <input
                            id="checkCal"
                            type="checkbox"
                            style={{ width: "15px" }}
                            checked={props.tasksComissioned}
                            onChange={props.setTasksComissioned}
                          />
                          zlecone
                        </div>
                        <div className="checkBox">
                          <input
                            id="checkCal"
                            type="checkbox"
                            style={{ width: "15px" }}
                            checked={props.tasksFinalized}
                            onChange={props.setTasksFinalized}
                          />
                          wykonane
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div className="checkBox">
                    <input
                      id="checkCal"
                      type="checkbox"
                      style={{ width: "20px" }}
                      checked={props.tasksSell}
                      onChange={props.setTasksSell}
                    />
                    KONTAKTY
                  </div>
                </>
              )}
            </>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      {props.user.role === "admin" ? (
        <>
          {expandFilters ? (
            <div className="detailFilters">
              <div className="titleBox">
                <div className="desktopFilters">
                  <span style={{ fontSize: "1.5vw" }} className="filterTitle">
                    FILTRY ZAAWANSOWANE
                  </span>
                </div>
                <div className="mobileFilters">
                  <span style={{ fontSize: "5vw" }} className="filterTitle">
                    FILTRY ZAAWANSOWANE
                  </span>
                </div>
                <button
                  style={{ fontSize: "1vw" }}
                  className="closeClientButton"
                  onClick={handleExpandFiltersClick}
                >
                  X
                </button>
              </div>

              <div className="filtersBox">
                {props.tasksCalendar ? (
                  <>
                    <div className="filterSubTitle">Rodzaj zadania</div>
                    <div className="checkBox">
                      <input
                        id="checkCal2"
                        type="checkbox"
                        checked={props.tasksCourtFilter}
                        onChange={props.setTasksCourtFilter}
                      />
                      ZADANIA SĄDOWE
                    </div>
                    <div className="checkBox">
                      <input
                        id="checkCal2"
                        type="checkbox"
                        checked={props.tasksNoCourtFilter}
                        onChange={props.setTasksNoCourtFilter}
                      />
                      ZADANIA POZASĄDOWE
                    </div>
                    <div className="checkBox">
                      <input
                        id="checkCal2"
                        type="checkbox"
                        checked={props.tasksNoClientFilter}
                        onChange={props.setTasksNoClientFilter}
                      />
                      ROZPRAWY NIEPOWIĄZANE
                    </div>
                    <div
                      className="filterSubTitle"
                      style={{ marginTop: "0px" }}
                    >
                      Typ zadania
                    </div>
                    <select
                      className="selectFilterDetail"
                      type="text"
                      id="court"
                      name="court"
                      value={props.taskTypeFilter}
                      onChange={handleTaskTypeFilterChange}
                    >
                      <option key="0" value="">
                        Wszystkie
                      </option>
                      {props.tasksTypesData.map((el) => (
                        <option key={el.name} value={el.name}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </>
                ) : (
                  ""
                )}
                <div style={{ height: "10px " }}></div>
                <div className="checkBox">
                  <input
                    id="checkCal2"
                    type="checkbox"
                    checked={hearingsZatrzPotr}
                    onChange={() => {
                      setHearingsZatrzPotr(!hearingsZatrzPotr);
                      getData(dateC);
                    }}
                  />
                  ROZPRAWY - ZARZUT POTRĄCENIA
                </div>
                <div style={{ height: "10px " }}></div>
                <div className="checkBox">
                  <input
                    id="checkCal2"
                    type="checkbox"
                    checked={hearingsPotrCl}
                    onChange={() => setHearingsPotrCl(!hearingsPotrCl)}
                  />
                  ROZPRAWY - POTRĄCENIE OTRZYMANE BEZPOŚREDNIO PRZEZ KLIENTA
                </div>
                <div style={{ height: "10px " }}></div>
                <div
                  className="checkBox"
                  style={{ textTransform: "uppercase" }}
                >
                  <input
                    id="checkCal2"
                    type="checkbox"
                    checked={teorSald}
                    onChange={() => setTeorSald(!teorSald)}
                  />
                  Sędzia - teoria salda
                </div>

                <div className="filterSubTitle">Rodzaj sprawy</div>
                <select
                  className="selectFilterDetail"
                  type="text"
                  id="court"
                  name="court"
                  value={props.clientTypeFilter}
                  onChange={handleClientTypeFilterChange}
                >
                  <option key="0" value="">
                    Wszystkie
                  </option>
                  <option key={"0a"} value="pozew przeciwko bankowi">
                    pozew przeciwko bankowi
                  </option>
                  <option
                    key={"1a"}
                    value="pozew banku o opłatę za korzystanie z kapitału i zwrot kapitału"
                  >
                    pozew banku o opłatę za korzystanie z kapitału i zwrot
                    kapitału
                  </option>
                  <option
                    key={"2a"}
                    value="pozew banku o opłatę za korzystanie z kapitału"
                  >
                    pozew banku o opłatę za korzystanie z kapitału
                  </option>
                  <option
                    key={"3a"}
                    value="pozew banku z tytułu wypowiedzenia umowy"
                  >
                    pozew banku z tytułu wypowiedzenia umowy
                  </option>
                  <option key={"4a"} value="pozew banku o waloryzację">
                    pozew banku o waloryzację
                  </option>
                  <option key={"5a"} value="pozew banku o zwrot kapitału">
                    pozew banku o zwrot kapitału
                  </option>
                  <option key={"6a"} value="sankcja kredytu darmowego">
                    sankcja kredytu darmowego
                  </option>
                  <option
                    key={"7a"}
                    value="pozew banku o zwrot kapitału i jego waloryzację"
                  >
                    pozew banku o zwrot kapitału i jego waloryzację
                  </option>
                  <option key={"8a"} value="EURO - pozew przeciwko bankowi">
                    EURO - pozew przeciwko bankowi
                  </option>
                  <option key={"9a"} value="WIBOR - pozew przeciwko bankowi">
                    WIBOR - pozew przeciwko bankowi
                  </option>
                  <option key={"9a"} value="antywindykacja">
                    antywindykacja
                  </option>
                </select>
                <div className="filterSubTitle">Wynik rozprawy</div>
                <select
                  className="selectFilterDetail"
                  type="text"
                  id="court"
                  name="court"
                  value={props.resultFilter}
                  onChange={handleResultFilterChange}
                >
                  <option key="0" value="">
                    Wszystkie
                  </option>
                  {results.map((r) => (
                    <option key={r.name} value={r.name}>
                      {r.name}
                    </option>
                  ))}
                </select>
                <div className="filterSubTitle">Przedmiot rozprawy</div>
                <select
                  className="selectFilterDetail"
                  type="text"
                  id="form"
                  name="form"
                  value={props.caseTypeFilter}
                  onChange={handleCaseTypeFilterChange}
                >
                  <option key="0" value="">
                    Wszystkie
                  </option>
                  <option key="1" value="Przesłuchanie strony">
                    Przesłuchanie strony
                  </option>
                  <option key="2" value="Przesłuchanie świadków">
                    Przesłuchanie świadków
                  </option>
                  <option key="3" value="Przesłuchanie strony i świadków">
                    Przesłuchanie strony i świadków
                  </option>
                  <option key="4" value="Apelacyjna">
                    Apelacyjna
                  </option>
                  <option key="5" value="Ogłoszenie wyroku">
                    Ogłoszenie wyroku
                  </option>
                  <option key="6" value="Inny">
                    Inny
                  </option>
                  <option key="6" value="Spotkanie mediacyjne">
                    Spotkanie mediacyjne
                  </option>
                </select>
                <div className="filterSubTitle">Forma rozprawy</div>
                <select
                  className="selectFilterDetail"
                  type="text"
                  id="form"
                  name="form"
                  value={props.caseFormFilter}
                  onChange={handleCaseFormFilterChange}
                >
                  <option key="0" value="">
                    Wsystkie
                  </option>
                  <option key="1" value="stacjonarna">
                    Stacjonarna
                  </option>
                  <option key="2" value="online">
                    Online
                  </option>
                </select>
                <div className="filterSubTitle">Sąd</div>
                <select
                  className="selectFilterDetail"
                  type="text"
                  id="form"
                  name="form"
                  value={props.courtFilter}
                  onChange={handleCourtFilterChange}
                >
                  <option key="0" value="">
                    Wszystkie
                  </option>
                  {props.courtsData.map((el) => (
                    <option key={el.name} value={el.name}>
                      {el.name}
                    </option>
                  ))}
                </select>
                <div className="filterSubTitle"></div>
              </div>
            </div>
          ) : (
            <>
              <button
                className="expandButton"
                onClick={handleExpandFiltersClick}
              >
                F<br />
                {"←"}
              </button>
            </>
          )}
        </>
      ) : (
        ""
      )}
      {showDate ? (
        <>
          <DatePopUp
            dateID={showDateId}
            hearingsData={hearings}
            tasksData={tasks}
            close={() => {
              setShowDate(false);
            }}
            lawyersData={props.lawyersData}
            substitutesData={props.substitutes}
            tasksTypesData={props.tasksTypesData}
            user={props.user}
            courtsData={props.courtsData}
            banksData={props.banksData}
            usersData={props.usersData}
            refreshData={props.refreshData}
            resultsData={props.resultsData}
            taskTypesData={props.tasksTypesData}
            history={false}
            checkPermissions={props.checkPermissions}
            team={props.team}
            tasksTeam2Data={props.tasksTeam2Data}
            hearingsTeam2Data={props.hearingsTeam2Data}
            clientsData={props.clientsData}
            filesData={props.filesData}
            logClientAction={props.logClientAction}
          />
        </>
      ) : (
        <>
          {showReportPopUp ? (
            <>
              <YearReportPopUp
                monthId={monthId}
                closeReport={closeReport}
                hearingsData={props.hearingsData}
                tasksData={props.tasksData}
                monthData={props.monthData}
                year={new Date(dateC).getFullYear()}
                users={props.users}
                user={props.user}
                hearingsTeam2Data={props.hearingsTeam2Data}
                tasksTeam2Data={props.tasksTeam2Data}
                team={props.team}
              />
            </>
          ) : (
            ""
          )}

          <>
            {loading ? (
              <Loading id="popUpLoading" />
            ) : (
              <>
                <div className="desktopFilters">{desktopFilters}</div>
                <div className="mobileFilters">{mobileFilters}</div>
                <div className="mainContainerCalendar">
                  {props.view === "month"
                    ? calendarMonthNew
                    : props.view === "year"
                    ? calendarYearNew
                    : props.view === "week"
                    ? calendarWeekNew
                    : props.view === "daily"
                    ? calendarDailyNew
                    : ""}
                </div>
                <CalendarViews view={props.view} setView={props.setView} />
              </>
            )}
          </>
        </>
      )}
    </>
  );
};

export default Calendar;
